import { Form, Radio, Select } from 'antd';
import { COMPANY_TYPE_OPTIONS, WORK_TYPES_OPTIONS } from '@/shared/company';
import { translateOptions } from '@/utils/utils';
import { useCompanyGeneralDataForm } from '../CompanyGeneralDataFormContext';

/** Company type, main company and work-from-home type. */
export default function CompanyTypeFields() {
  const {
    companyIsLoading,
    companyOptions,
    hasBranchCompanyType,
    inSection,
    isProfile,
    mainCompanyKeys,
    mainCompanyState,
    sectionClass,
    t,
    typeOfCompanyKeys,
    typeOfCompanyState,
    workFromHomeTypeKeys,
    workFromHomeTypeState,
  } = useCompanyGeneralDataForm();

  return (
    <>
      {typeOfCompanyState?.visible && (
        <div className={sectionClass('osnovno')}>
          {!isProfile && <hr className="my-5" />}

          <Form.Item
            name={typeOfCompanyKeys}
            label={t('companyType', { ns: 'forms' })}
            className="!mb-5"
          >
            <Radio.Group
              className="custom-ant-radio-label custom-ant-radio-group"
              disabled={typeOfCompanyState?.disabled}
              options={translateOptions(COMPANY_TYPE_OPTIONS, t)}
            />
          </Form.Item>
        </div>
      )}

      {hasBranchCompanyType && mainCompanyState?.visible && (
        <Form.Item
          hidden={!inSection('osnovno')}
          name={mainCompanyKeys}
          label={t('mainCompany', { ns: 'forms' })}
          rules={[
            {
              required: true,
              message: t('formValidation.mainCompanyRequired', {
                ns: 'forms',
              }),
            },
          ]}
        >
          <Select
            allowClear
            mode="single"
            placeholder={t('mainCompany', { ns: 'forms' })}
            className="w-full"
            loading={companyIsLoading}
            options={companyOptions || []}
            disabled={companyIsLoading && mainCompanyState?.disabled}
          />
        </Form.Item>
      )}

      {/* On the profile it sits in CompanyHrProfilePanel. */}
      {!isProfile && workFromHomeTypeState?.visible && (
        <div className={sectionClass('hr')}>
          {!isProfile && <hr className="my-5" />}

          <Form.Item
            name={workFromHomeTypeKeys}
            label={t('workFromHome', { ns: 'forms' })}
            className="!mb-5"
          >
            <Radio.Group
              className="custom-ant-radio-label custom-ant-radio-group"
              disabled={workFromHomeTypeState?.disabled}
              options={translateOptions(WORK_TYPES_OPTIONS, t)}
            />
          </Form.Item>
        </div>
      )}
    </>
  );
}
